import $http from "../../axios"
import { Notification, MessageBox } from 'element-ui'

export async function fetchUpdateMasiveRetentions ({ commit, state },retentions) {
    let params ={
        type_contact : state.type_contact,
        retentions
    }
  await $http.post('/api/actualizar-masivo-retenciones', params).then((res) => {
      if(res.data.rows == 0){

          Notification.warning({
              title: '¡UPS!',
              message: `No se han encontrados registros a actualizar con la informacoin actual`,
              type: 'warning',
              duration: 1500,
              customClass: 'notification-box'
          })
      }else{
          Notification.success({
              title: '¡Success!',
              message: `Se han actualizado correctamente ${res.data.rows} Registros`,
              type: 'success',
              duration: 1500,
              customClass: 'notification-box'
          })
      }
  }).catch((error) => {
    Notification.error({
      title: '¡Error!',
      message: error.message,
      type: 'error',
      duration: 1500,
      customClass: 'notification-box'
    })
  });
}




// WEBPACK FOOTER //
// ./src/modules/update-withholdings/actions.js